// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"fq-z","imageAndVideoCount":"gq-z","imageAndVideoContainer":"hq-z","viewAllReviews":"iq-z"};